import { createGlobalStyle } from 'styled-components';

const TextFontFamily = 'Neue Montreal';

const GlobalStyles = createGlobalStyle`
  body {
    margin: 0;
    font-family: '${TextFontFamily}', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .PylonChat-bubbleFrameContainer {
    left: 8px;
  }
  .PylonChat-chatWindowFrameContainer {
    left: 24px;
  }
`;

export default GlobalStyles;
